import { type FieldNames, FORM_FIELD } from '@mnd-frontend/ui/public/components/Form/index.type';

export const REGEX = {
  [FORM_FIELD.PHONE]: /[0-9\- ()[\]]/g,
  [FORM_FIELD.NAME]: /[^0-9!#%&:;<=>@_~^$*+?()[\]{}\\|/]/g,
};

export const sanitizeByPattern = (
  fieldName: Extract<FieldNames, 'name' | 'phone'>,
  userInput: string,
) => userInput.trim().match(REGEX[fieldName])?.join('') || '';
